import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { AdminLayout } from '@/components/AdminLayout';
import { Store, ShoppingCart, DollarSign, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

const AdminDashboard = () => {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMetrics();
  }, []);

  const fetchMetrics = async () => {
    try {
      const res = await axios.get(`${API}/admin/metrics`);
      setMetrics(res.data);
    } catch (e) {
      toast.error('Erro ao carregar métricas');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout title="Dashboard">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#ff6b00]"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Dashboard">
      <div className="space-y-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          <Card className="card-adegga">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-white/60">Total de Lojas</p>
                  <p className="text-3xl font-bold text-white">{metrics?.total_stores || 0}</p>
                </div>
                <div className="w-12 h-12 rounded-lg bg-[#ff6b00]/20 flex items-center justify-center">
                  <Store className="w-6 h-6 text-[#ff6b00]" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="card-adegga">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-white/60">Lojas Ativas</p>
                  <p className="text-3xl font-bold text-green-400">{metrics?.active_stores || 0}</p>
                </div>
                <div className="w-12 h-12 rounded-lg bg-green-500/20 flex items-center justify-center">
                  <TrendingUp className="w-6 h-6 text-green-400" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="card-adegga">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-white/60">Total de Pedidos</p>
                  <p className="text-3xl font-bold text-white">{metrics?.total_orders || 0}</p>
                </div>
                <div className="w-12 h-12 rounded-lg bg-blue-500/20 flex items-center justify-center">
                  <ShoppingCart className="w-6 h-6 text-blue-400" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="card-adegga">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-white/60">GMV Total</p>
                  <p className="text-3xl font-bold text-[#ff6b00]">
                    R$ {(metrics?.gmv || 0).toFixed(2)}
                  </p>
                </div>
                <div className="w-12 h-12 rounded-lg bg-[#ff6b00]/20 flex items-center justify-center">
                  <DollarSign className="w-6 h-6 text-[#ff6b00]" />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
